// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"3c73e5bd","59":"53013566","111":"17f59739","355":"029e12ba","368":"1256e977","629":"fad7f5d6","891":"e4c3dfb9","920":"ab2b601d","982":"0982f572"}[chunkId] + ".chunk.js";
};